import { render } from "./BasePage.vue?vue&type=template&id=390363e9&lang=html"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__